var _Path, _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G, Mask, Circle, Rect, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
function SvgAppointmentVisit(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 98,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M71.884 86.554c-23.588 13.852-52.507 7.82-64.594-13.473C-4.796 51.788 4.528 23.298 28.116 9.446 51.704-4.406 80.623 1.626 92.71 22.919c12.086 21.293 2.762 49.783-20.826 63.635z",
    fill: "#C0E9D3"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#appointment-visit_svg__filter0_d_2365_44900)"
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "appointment-visit_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.29 9.003c5.124 4.653 4.126 11.5-2.23 15.292-3.402 2.03-7.65 2.774-11.65 2.312a8.108 8.108 0 01-1.866 1.477 8.071 8.071 0 01-3.979 1.088 11 11 0 001.587-3.56c-1.834-.668-3.505-1.63-4.877-2.876-5.124-4.653-4.126-11.5 2.23-15.292C44.86 3.652 54.165 4.35 59.29 9.003z"
  })), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.29 9.003c5.124 4.653 4.126 11.5-2.23 15.292-3.402 2.03-7.65 2.774-11.65 2.312a8.108 8.108 0 01-1.866 1.477 8.071 8.071 0 01-3.979 1.088 11 11 0 001.587-3.56c-1.834-.668-3.505-1.63-4.877-2.876-5.124-4.653-4.126-11.5 2.23-15.292C44.86 3.652 54.165 4.35 59.29 9.003z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M57.06 24.295l.513.858-.513-.858zm2.23-15.292l-.673.74.673-.74zM45.41 26.607l-.73-.684.344-.367.5.057-.114.994zm-1.866 1.477l.5.866-.5-.866zm-3.979 1.088l.008 1-1.91.016 1.076-1.579.826.563zm1.587-3.56l.342-.94.844.308-.215.872-.971-.24zm-4.877-2.876l-.672.74.672-.74zm20.273.7c2.972-1.773 4.59-4.195 4.942-6.609.35-2.399-.526-4.953-2.873-7.084l1.345-1.48c2.777 2.522 3.964 5.717 3.507 8.853-.455 3.12-2.513 6.018-5.896 8.038l-1.025-1.718zm-11.024 2.177c3.813.44 7.835-.274 11.024-2.177l1.025 1.718c-3.617 2.158-8.092 2.93-12.278 2.446l.23-1.987zm-2.48 1.605a7.11 7.11 0 001.636-1.295l1.459 1.368c-.599.639-1.3 1.2-2.095 1.66l-1-1.733zm-3.487.954a7.072 7.072 0 003.487-.954l1 1.732a9.071 9.071 0 01-4.47 1.222l-.017-2zm2.566-2.32a12.003 12.003 0 01-1.731 3.883l-1.654-1.126a10.003 10.003 0 001.443-3.236l1.942.479zm-5.175-3.856c1.262 1.147 2.817 2.046 4.546 2.677l-.684 1.879c-1.939-.707-3.727-1.731-5.207-3.075l1.345-1.481zm2.07-13.693c-2.973 1.773-4.591 4.195-4.943 6.609-.35 2.399.526 4.953 2.873 7.084l-1.345 1.48c-2.778-2.522-3.964-5.717-3.507-8.853.455-3.12 2.513-6.018 5.896-8.038l1.025 1.718zm19.6 1.44c-2.364-2.146-5.745-3.42-9.334-3.69-3.586-.268-7.29.474-10.267 2.25l-1.025-1.718c3.379-2.016 7.505-2.821 11.442-2.526 3.933.295 7.767 1.696 10.528 4.203l-1.345 1.481z",
    fill: "#2F2F2F",
    mask: "url(#appointment-visit_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6 10.694a.519.519 0 00-.52.519v2.775H43.34a.519.519 0 00-.519.519v2.258c0 .286.233.519.519.519h2.742v2.778c0 .286.232.518.518.518h2.219a.519.519 0 00.518-.518v-2.778h2.732a.519.519 0 00.518-.519v-2.258a.519.519 0 00-.518-.519h-2.732v-2.775a.519.519 0 00-.518-.519h-2.219z",
    fill: "#FF4259"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M5.606 59.194c8.355-17.237 26.08-20.366 40.548-.48C47.48 60.536 46.114 63 43.86 63H8.13c-2.006 0-3.4-2-2.524-3.806z",
    fill: "#8ED7AF",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 33.5,
    cy: 59.5,
    r: 6.5,
    fill: "#F6F5F3",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M33.5 59.5V47",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 33.5,
    cy: 59.5,
    r: 2.5,
    transform: "rotate(-180 33.5 59.5)",
    fill: "#FFCED3",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M22.571 66h.122c.722 0 1.307-.612 1.307-1.367v-.257c0-3.523-2.077-6.681-5.223-7.937a6.115 6.115 0 00-4.547 0C11.082 57.693 9 60.853 9 64.38v.252C9 65.387 9.585 66 10.307 66h.121",
    stroke: "#2F2F2F",
    strokeWidth: 1.004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M16.5 56v-9",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 10,
    y: 65,
    width: 3,
    height: 2,
    rx: 1,
    fill: "#FFE5E5",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 20,
    y: 65,
    width: 3,
    height: 2,
    rx: 1,
    fill: "#FFE5E5",
    stroke: "#2F2F2F",
    strokeWidth: 0.966
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M90.184 72.43c-10.076-18.956-31.712-22.417-49.291-.502-1.45 1.808-.106 4.397 2.212 4.397h44.6c2.052 0 3.442-2.084 2.48-3.895z",
    fill: "#C1D4F7",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M81.25 43.156c-2.444 7.53-10.133 12.223-17.175 10.48-7.042-1.742-10.77-9.26-8.325-16.792 2.444-7.53 10.133-12.223 17.175-10.48 7.042 1.742 10.77 9.26 8.325 16.792zM12.324 30.178c.392 6.23 5.49 11.414 11.386 11.576 5.897.162 10.36-4.757 9.967-10.989-.392-6.23-5.49-11.414-11.386-11.576-5.897-.162-10.36 4.758-9.967 10.989z",
    fill: "#fff",
    stroke: "#2F2F2F"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}
export default SvgAppointmentVisit;